import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionBlogs from "../../../components/sections/front/Blogs/SectionBlogs";
import { useBanner } from "../../../providers/BannerProviders";

const BlogList = () => {
  const { data } = useBanner();
  const blogBanner = data?.data?.find(
    (item) => item?.bannerType === "updatesAndBlogs"
  );

  return (
    <>
      <PageBanner title={"Blogs"} image={blogBanner?.blogBannerImage?.url} />
      <SectionBlogs />
      <OurPartners />
    </>
  );
};

export default BlogList;
